import {
    SYSTEM_SUBMIT_EDU_BEGIN,
    SYSTEM_SUBMIT_EDU_SUCCESS,
    SYSTEM_SUBMIT_EDU_FAILURE,
    SYSTEM_SUBMIT_EDU_DISMISS_ERROR,
} from './constants';
import request from '../../../utils/request'

export function submitEdu(params) {
    return (dispatch) => { // optionally you can have getState as the second argument
      dispatch({
        type: SYSTEM_SUBMIT_EDU_BEGIN,
      });
  
      let apiurl = '/api/b/edu/add';
    
    if (params.id != undefined){
      apiurl = '/api/b/edu/update';
    }

    const promise = new Promise((resolve, reject) => {
        request({
          method:'post',
          url:apiurl,
          data: params,
        }).then( data => {
            dispatch({
                type: SYSTEM_SUBMIT_EDU_SUCCESS,
                data: data,
            });
            resolve(data);
        }).catch (error => {
            dispatch({
              type: SYSTEM_SUBMIT_EDU_FAILURE,
              data: { error: error },
            });
            reject(error);
        })
    });
  
      return promise;
    };
  }
  
  // Async action saves request error by default, this method is used to dismiss the error info.
  // If you don't want errors to be saved in Redux store, just ignore this method.
  export function dismissSubmitEduError() {
    return {
      type: SYSTEM_SUBMIT_EDU_DISMISS_ERROR,
    };
  }
  
  export function reducer(state, action) {
    switch (action.type) {
      case SYSTEM_SUBMIT_EDU_BEGIN:
        // Just after a request is sent
        return {
          ...state,
          submitEduPending: true,
          submitEduError: null,
        };
  
      case SYSTEM_SUBMIT_EDU_SUCCESS:
        // The request is success
        return {
          ...state,
          submitEduPending: false,
          submitEduError: null,
        };
  
      case SYSTEM_SUBMIT_EDU_FAILURE:
        // The request is failed
        return {
          ...state,
          submitEduPending: false,
          submitEduError: action.data.error,
        };
  
      case SYSTEM_SUBMIT_EDU_DISMISS_ERROR:
        // Dismiss the request failure error
        return {
          ...state,
          submitEduError: null,
        };
  
      default:
        return state;
    }
  }
  


// WEBPACK FOOTER //
// ./src/features/system/redux/submitEdu.js